import React, { useState, useEffect, useContext } from 'react';
// import PropTypes from "prop-types";
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import { AgGrid } from '../../AgGrid';
import { DynamicFormModal } from '../../DynamicForm';
// import * as v from "../../../helpers/validation";
import { OrderDetailContext } from '../OrderDetailContext';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, LinearProgress, Checkbox } from '@material-ui/core';

// SERVICES
import { addServiceToOrderLine, getOrderableServices, getOrderServices } from '../../../services';

const ColoredCheckbox = withStyles({
  root: {
    color: '#315382',
    '&$checked': {
      color: '#315382',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

const styles = theme => ({
  textInput: {
    background: 'transparent',
    // alignSelf: 'stretch',
    fontSize: 16,

    border: '1px solid #aaa',
    borderRadius: 5,
    padding: 10,

    '&:focus': {
      outline: 'none',
    },
  },
});

export const OrderDetailServicesTab = withStyles(styles)(({ classes, orderLineId }) => {
  const {
    state: { services },
    dispatch,
  } = useContext(OrderDetailContext);

  const [orderableServices, setOrderableServices] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [selectedServiceTypeIds, setSelectedServiceTypeIds] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);
  const [serviceModalVisible, setServiceModalVisible] = useState(false);
  const [serviceTypeIdsShowPayable, setServiceTypeIdsShowPayable] = useState([]); // calculated on return from the GET request to determine which services should show the input for payableAmount

  const servicesColDefs = [
    { headerName: 'Service Type', field: 'serviceType.name' },
    { headerName: 'Service Status', field: 'serviceStatus.code' },
    { headerName: 'Priority Weight', field: 'priorityWeight' },
    { headerName: 'Created On', field: 'createdOn', cellRenderer: 'dateUTC' },
    { headerName: 'Created By', field: 'createdBy' },
    { headerName: 'Modified On', field: 'modifedOn', cellRenderer: 'dateUTC' }, // TODO: changed spelling to modifiedOn
    { headerName: 'Modified By', field: 'modifiedBy' },
    { headerName: 'Assigned To', field: 'assignedTo' },
    // { headerName: "", field: "", },
  ];

  const addServiceInputs = [
    {
      inputType: 'checkbox',
      field: 'services',
      label: 'Orderable/Available Services',
      validate: [],
      options: orderableServices,
      noOptionsMessage: 'There are currently no orderable services available...',
    },
  ];

  // get existing details for the grid
  const getServiceDetailsAsync = async () => {
    try {
      const res = await getOrderServices(orderLineId);
      // setServicesData(res);
      dispatch({
        type: 'UPDATE_SERVICES',
        services: res,
      });
    } catch (err) {
      console.log(err);
    }
  };

  // get orderable options allowed to be added by the user
  const getOrderableServicesAsync = async () => {
    try {
      const res = await getOrderableServices(orderLineId);

      setServiceTypes(res);
      setServiceTypeIdsShowPayable(res.filter(st => st.payableAmount === null).map(st => st.serviceTypeId));
    } catch (err) {}
  };

  const addServiceToOrderLineAsync = async () => {
    const servicesToAdd = serviceTypes.filter(st => selectedServiceTypeIds.includes(st.serviceTypeId));

    if (!servicesToAdd.length) return;

    try {
      setIsSubmitting(true);
      setSubmitMessage(null);

      // loop through each service to add
      for (let i = 0; i < servicesToAdd.length; i++) {
        const serviceToAdd = servicesToAdd[i];
        await addServiceToOrderLine(orderLineId, serviceToAdd);
      }

      setSubmitMessage('Services added!');

      setTimeout(() => {
        setSubmitMessage(null);
        setServiceModalVisible(false);
      }, 1000);

      // clear services
      setOrderableServices([]);
      // setServiceTypes([]);
      getOrderableServicesAsync();
      getServiceDetailsAsync();
    } catch (error) {
      setSubmitMessage('Something went wrong...');
    }
    setIsSubmitting(false);
  };

  const toggleServiceTypeSelected = st => () => {
    const isSelected = selectedServiceTypeIds.includes(st.serviceTypeId);

    if (isSelected) {
      setSelectedServiceTypeIds(selectedServiceTypeIds.filter(id => id !== st.serviceTypeId));
    } else {
      setSelectedServiceTypeIds(selectedServiceTypeIds.concat(st.serviceTypeId));
    }
  };

  const handleServicePayableChange = serviceTypeIndex => evt => {
    const { value } = evt.target;

    const parsedValue = value.length ? parseFloat(value) : null;

    if (isNaN(parsedValue) || parsedValue === null) return;

    const tempServiceTypes = serviceTypes.slice();
    tempServiceTypes[serviceTypeIndex].payableAmount = parsedValue;
    setServiceTypes(tempServiceTypes);
  };

  useEffect(() => {
    getOrderableServicesAsync();
    if (!services) {
      getServiceDetailsAsync();
      // updateLoaded(true);
    }
  }, []);

  return (
    <div className={cn('flex-1', 'col-center-center')}>
      <AgGrid
        gridName="ORDER_DETAIL_SERVICES"
        gridData={services}
        columnDefs={servicesColDefs}
        redirectOnClick={false}
        editOnClick={false}
        showCreateButton={true}
        handleCreateClick={evt => {
          setServiceModalVisible(true);
        }}
      />
      {/* <DynamicForm
        inputs={detailInputs}
        mode={"EDIT"}
        data={detailData}
        onSave={orderDetails => {
          // return saveContent('EDIT', orderDetails, d => orderService.updateOrderLine(d));
        }}
      /> */}

      {/* Form Modal for adding services to Order Line */}
      {/* <DynamicFormModal
        inputs={addServiceInputs}
        mode={'CREATE'}
        onSave={addServiceToOrderLineAsync}
        modalVisible={serviceModalVisible}
        hideModal={() => setServiceModalVisible(false)}
        modalChildType={'input'}
        hideSubmitButton={!orderableServices.length}
        // hideSubmitButton={!serviceTypes.length}
        clearStateAfterSave={true}
        modalLabel={'Add Services'}
      /> */}

      <Dialog
        open={serviceModalVisible}
        onClose={() => setServiceModalVisible(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>Add Services</DialogTitle>
        <DialogContent
          dividers
          style={{
            minWidth: 500,
            minHeight: 400,
            borderTop: '0.8px solid #ddd',
            borderBottom: '0.8px solid #ddd',
            paddingTop: 20,
            pointerEvents: isSubmitting ? 'none' : 'auto',
            opacity: isSubmitting ? 0.5 : 1,
          }}
        >
         { serviceTypes.length == 0 ? <span>No Available Services to Add</span> :
          serviceTypes.map((service, serviceIdx) => {
            return (
              <div className={cn('row-between-center mb-15')}>
                <div>
                  <ColoredCheckbox
                    checked={selectedServiceTypeIds.includes(service.serviceTypeId)}
                    onChange={toggleServiceTypeSelected(service)}
                  />
                  {service.name}
                </div>
                <div>
                  {serviceTypeIdsShowPayable.includes(service.serviceTypeId) && (
                    <React.Fragment>
                      <span className="mr-10">$</span>
                      <input
                        type="number"
                        className={cn(classes.textInput)}
                        placeholder="Payable Amount"
                        onChange={handleServicePayableChange(serviceIdx)}
                        value={service.payableAmount}
                      />
                    </React.Fragment>
                  )}
                </div>
              </div>
            );
          })}
        </DialogContent>
        <DialogActions
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Button
            onClick={() => setServiceModalVisible(false)}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white' }}
          >
            Cancel
          </Button>
          <div style={{ flex: 1, paddingLeft: 10, paddingRight: 10 }}>
            {isSubmitting && <LinearProgress />}
            {submitMessage && <div>{submitMessage}</div>}
          </div>
          <Button
            disabled={isSubmitting }
            onClick={addServiceToOrderLineAsync}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white' }}
          >
            Add Services
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

OrderDetailServicesTab.propTypes = {};

OrderDetailServicesTab.defaultProps = {};
